import React from "react";
import { Modal } from "../Modal";
import styles from "./Thanks.css";
import EnvelopeIcon from "./envelope.svg";

interface ThanksProps {
  onClose: () => void;
}

export const Thanks: React.FC<ThanksProps> = ({ onClose }) => {
  return (
    <Modal onClose={onClose}>
      <div className={styles.wrapper}>
        <div className={styles.iconWrapper}>
          <EnvelopeIcon />
        </div>
        <div className={styles.messageWrapper}>
          <p className={styles.successMessage}>Sua avaliação foi enviada!</p>
        </div>
        <div className={styles.buttonWrapper}>
          <span className={styles.successButton} onClick={onClose}>
            Entendi!
          </span>
        </div>
      </div>
    </Modal>
  );
};
